'use client'
import type { FC } from 'react'
import { Text, VStack } from '@chakra-ui/react'
import { RealEstateDTO, RealEstateLightDTO } from '@/core/real-estate/typings'
import { AddressDisplay } from '@/lib/address/components/AddressDisplay'

interface RealEstateAddressProps {
  item: RealEstateLightDTO | RealEstateDTO
}

const RealEstateAddress: FC<RealEstateAddressProps> = ({ item }) => {
  return (
    <VStack w="full" align="flex-start">
      <Text className="address-street" fontSize="xl" fontWeight="bold" color="primary">
        {item.name}
      </Text>
      <AddressDisplay address={item.address} />
    </VStack>
  )
}

export default RealEstateAddress
